import { c as _c } from "react/compiler-runtime";
import capitalize from "utils/helpers/captizalize";
import { cn } from "utils/helpers/cn";
export interface SelectItemProps {
  id: string;
  value: string;
  isSelected: boolean;
  onClick: () => void;
  dataTestId: string;
  ref: (el: HTMLLIElement | null) => void;
}
export const SelectItem = t0 => {
  const $ = _c(12);
  const {
    ref,
    id,
    value,
    isSelected,
    onClick,
    dataTestId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("group flex cursor-pointer items-center gap-n2 rounded-sm px-2 py-1.5 text-foreground text-sm", "hover:bg-primary-foreground hover:text-black", "focus:outline-hidden focus:ring-2 focus:ring-ring");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== value) {
    t2 = capitalize(value);
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span>{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== dataTestId || $[6] !== id || $[7] !== isSelected || $[8] !== onClick || $[9] !== ref || $[10] !== t3) {
    t4 = <li onClick={onClick} id={id} data-test-id={dataTestId} role="option" aria-selected={isSelected} className={t1} ref={ref} tabIndex={-1}>{t3}</li>;
    $[5] = dataTestId;
    $[6] = id;
    $[7] = isSelected;
    $[8] = onClick;
    $[9] = ref;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};